/* assets/meters-quantity.js */
(() => {
  if (window.MetersQty) return;

  const API = {
    initAll: () => initWithin(document),
    initWithin,
  };
  window.MetersQty = API;

  function normalize(s) {
    return String(s || "").trim().replace(",", ".");
  }

  function isValidMax2Decimals(raw) {
    return /^\d+([.,]\d{0,2})?$/.test(String(raw || "").trim());
  }

  // Sanitizza duramente: solo цифre + 1 separatore + max 2 decimali
  function sanitizeToMax2Decimals(raw) {
    raw = String(raw || "").replace(/\s+/g, "");
    raw = raw.replace(/[^\d.,]/g, "");

    const firstSepIdx = raw.search(/[.,]/);
    if (firstSepIdx !== -1) {
      const sep = raw[firstSepIdx];
      const before = raw.slice(0, firstSepIdx).replace(/[^\d]/g, "");
      const after = raw.slice(firstSepIdx + 1).replace(/[^\d]/g, "");
      return after.length ? `${before}${sep}${after.slice(0, 2)}` : `${before}${sep}`;
    }

    return raw.replace(/[^\d]/g, "");
  }

  // Converte metri stringa -> unità intera (cm se factor=100, dm se factor=10) senza float
  function metersStringToUnitInt(raw, factor) {
    const t = String(raw || "").trim();
    if (!t) return null;

    if (!isValidMax2Decimals(t)) return "INVALID";

    const norm = normalize(t);
    const [intPartRaw, decPartRaw = ""] = norm.split(".");
    const intPart = parseInt(intPartRaw, 10);
    if (!Number.isFinite(intPart)) return null;

    const dec2 = (decPartRaw + "00").slice(0, 2);
    const d1 = parseInt(dec2[0] || "0", 10);
    const d2 = parseInt(dec2[1] || "0", 10);

    // modalità "cm" (vecchia)
    if (factor === 100) {
      const decPart = parseInt(dec2, 10);
      return intPart * 100 + decPart;
    }

    // modalità "dm" (nuova): accetta solo multipli di 0,10 m
    if (factor === 10) {
      // se ci sono 2 decimali, il secondo deve essere 0 (es. 1,20 ok; 1,23 no)
      if (decPartRaw.length >= 2 && d2 !== 0) return "INVALID_STEP";
      // "1,2" lo consideriamo 1,20
      return intPart * 10 + d1;
    }

    return null;
  }

  function cmToMetersDisplay(cm, factor) {
    const m = cm / factor;
    return m.toFixed(2).replace(".", ","); // sempre 2 decimali
  }

  function initWithin(root) {
    root.querySelectorAll(".js-meters-qty").forEach(initWrap);
    root.querySelectorAll(".js-quantity-max").forEach(initPiecesWrap);
  }

  // Stesso comportamento righe 166-171: se superi la quantità massima → showError + blocca submit
  function initPiecesWrap(wrap) {
    if (!wrap || wrap.dataset.quantityMaxInit === "1") return;
    const input = wrap.querySelector('input[name="quantity"]');
    const errorEl = wrap.querySelector(".js-meters-qty__error");
    if (!input) return;
    const maxRaw = input.dataset.max || input.getAttribute("max");
    if (maxRaw == null || maxRaw === "") return;
    const maxNum = parseInt(maxRaw, 10);
    if (!Number.isFinite(maxNum)) return;
    wrap.dataset.quantityMaxInit = "1";

    const showError = (msg = "", showInDom = false) => {
      input.setCustomValidity(msg || "");
      if (errorEl) {
        if (showInDom) {
          errorEl.textContent = msg || "";
          errorEl.hidden = !msg;
        } else {
          errorEl.textContent = "";
          errorEl.hidden = true;
        }
      }
    };

    const validate = (showInDom = false) => {
      const val = parseInt(input.value, 10);
      if (!Number.isFinite(val) || val <= maxNum) {
        showError("", true);
        return true;
      }
      showError(`Disponibilità massima: ${maxNum}`, showInDom);
      return false;
    };

    const formId = input.getAttribute("form");
    const formEl = formId ? document.getElementById(formId) : input.form;
    if (formEl && !formEl.__quantityMaxSubmitBound) {
      formEl.__quantityMaxSubmitBound = true;
      formEl.addEventListener(
        "submit",
        (e) => {
          const wraps = formEl.querySelectorAll(".js-quantity-max");
          for (const w of wraps) {
            const inp = w.querySelector('input[name="quantity"]');
            if (!inp) continue;
            const maxR = inp.dataset.max || inp.getAttribute("max");
            if (maxR == null || maxR === "") continue;
            const mx = parseInt(maxR, 10);
            const v = parseInt(inp.value, 10);
            if (Number.isFinite(v) && v > mx) {
              e.preventDefault();
              e.stopPropagation();
              inp.setCustomValidity("Disponibilità massima: " + mx);
              const err = w.querySelector(".js-meters-qty__error");
              if (err) {
                err.textContent = "Disponibilità massima: " + mx;
                err.hidden = false;
              }
              inp.reportValidity();
              return;
            }
            inp.setCustomValidity("");
          }
        },
        true
      );
    }

    input.addEventListener("input", () => validate(false));
    input.addEventListener("change", () => validate(false));
    input.addEventListener("blur", () => validate(false));
  }

  function initWrap(wrap) {
    if (!wrap || wrap.dataset.metersQtyInit === "1") return;
    wrap.dataset.metersQtyInit = "1";

    // ✅ fallback a 10 (dm) per evitare ritorni “silenziosi” a 100
    const factor = parseInt(wrap.dataset.factor || "10", 10);

    const metersInput = wrap.querySelector(".js-meters-qty__meters");
    const cmInput = wrap.querySelector(".js-meters-qty__cm");
    const errorEl = wrap.querySelector(".js-meters-qty__error");
    const propInput = wrap.querySelector(".js-meters-qty__prop");

    if (!metersInput || !cmInput) return;

    const isCartUpdates = cmInput.getAttribute("name") === "updates[]";

    if (!isCartUpdates) {
      const formId = cmInput.getAttribute("form");
      const formEl =
        formId && document.getElementById(formId) ? document.getElementById(formId) : cmInput.form;

      if (formEl && !formEl.__metersQtySubmitBound) {
        formEl.__metersQtySubmitBound = true;

        formEl.addEventListener(
          "submit",
          (e) => {
            const wraps = formEl.querySelectorAll(".js-meters-qty");
            for (const w of wraps) {
              const mi = w.querySelector(".js-meters-qty__meters");
              const ci = w.querySelector(".js-meters-qty__cm");
              if (!mi || !ci) continue;

              mi.dispatchEvent(new Event("change", { bubbles: true }));

              if (!mi.checkValidity()) {
                e.preventDefault();
                e.stopPropagation();
                mi.reportValidity();
                break;
              }
            }
          },
          true
        );
      }
    }

    const showError = (msg = "") => {
      if (errorEl) {
        if (isCartUpdates && msg) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        } else {
          errorEl.textContent = "";
          errorEl.hidden = true;
        }
      }
      metersInput.setCustomValidity(msg || "");
    };

    const getRules = () => {
      const minRaw = cmInput.dataset.min ?? cmInput.getAttribute("min");
      const maxRaw = cmInput.dataset.max ?? cmInput.getAttribute("max");

              const minCm = Math.max(Number.isFinite(parseInt(minRaw, 10)) ? parseInt(minRaw, 10) : 0, 5); // minimo 50cm = 5dm
      const maxCm =
        maxRaw !== null && maxRaw !== "" && maxRaw !== "null" && Number.isFinite(parseInt(maxRaw, 10))
          ? parseInt(maxRaw, 10)
          : null;

      return { minCm, maxCm };
    };

    const clampCm = (cm) => {
      const { minCm, maxCm } = getRules();
      cm = Math.max(minCm, cm);
      if (maxCm !== null && !Number.isNaN(maxCm)) cm = Math.min(maxCm, cm);
      return cm;
    };

    const triggerCartUpdate = () => {
      if (!isCartUpdates) return;
      cmInput.dispatchEvent(new Event("input", { bubbles: true }));
      cmInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    const getUpdatedPropertiesForCart = () => {
      if (!isCartUpdates) return null;
      const currentMeters = metersInput.value.trim().replace(",", ".") + " m";
      const rawProps = wrap.dataset.properties;
      let props = {};

      if (rawProps) {
        try {
          const parsed = JSON.parse(rawProps);
          if (Array.isArray(parsed)) {
            // Shopify/Liquid può serializzare item.properties come array di coppie
            // [key, value] o oggetti { first, last }.
            parsed.forEach((entry) => {
              if (Array.isArray(entry) && entry.length >= 2) {
                const key = String(entry[0] ?? "").trim();
                if (key) props[key] = entry[1];
                return;
              }
              if (entry && typeof entry === "object") {
                const key = String(entry.first ?? entry.key ?? "").trim();
                const value = entry.last ?? entry.value ?? "";
                if (key) props[key] = value;
              }
            });
          } else if (parsed && typeof parsed === "object") {
            props = { ...parsed };
          }
        } catch (e) {
          props = {};
        }
      }

      // Pulisce eventuali chiavi legacy numeriche generate da update precedenti.
      Object.keys(props).forEach((key) => {
        if (/^\d+$/.test(key)) delete props[key];
      });

      let hasMetriKey = false;
      Object.keys(props).forEach((key) => {
        if (/metri/i.test(key)) {
          props[key] = currentMeters;
          hasMetriKey = true;
        }
      });

      if (!hasMetriKey) props.Metri = currentMeters;
      return props;
    };

    const applyFromMeters = (forceRewrite, triggerUpdate) => {
      const raw = sanitizeToMax2Decimals(metersInput.value);
      if (raw !== metersInput.value) metersInput.value = raw;

      const trimmed = String(raw || "").trim();

      // ✅ stato intermedio: "1," / "1." -> deve BLOCCARE
      if (/^\d+[.,]$/.test(trimmed)) {
        showError("Completa il valore (es. 1,20)");
        return false;
      }

      // ✅ vuoto non valido in submit/change
      if (!trimmed) {
        showError("Inserisci un valore valido (es. 1,20)");
        return false;
      }

      if (!isValidMax2Decimals(trimmed)) {
        showError("Inserisci un valore valido (es. 1,20)");
        return false;
      }

      const cmRaw = metersStringToUnitInt(trimmed, factor);

      if (cmRaw === "INVALID_STEP") {
        showError("Inserisci multipli di 0,10 m (es. 1,20)");
        return false;
      }

      if (cmRaw === "INVALID" || cmRaw === null) {
        showError("Inserisci un valore valido (es. 1,20)");
        return false;
      }

      const { minCm, maxCm } = getRules();

      if (cmRaw < minCm) {
        showError(`Minimo: ${cmToMetersDisplay(minCm, factor)} m`);
        return false;
      }

      if (maxCm !== null && cmRaw > maxCm) {
        showError(`Disponibilità massima: ${cmToMetersDisplay(maxCm, factor)} m`);
        return false;
      }

      showError("");
      cmInput.value = String(cmRaw);

      if (forceRewrite) metersInput.value = cmToMetersDisplay(cmRaw, factor);
      if (propInput) propInput.value = metersInput.value.trim().replace(",", ".") + " m";
      if (triggerUpdate) triggerCartUpdate();

      return true;
    };

    // INIT: usa il valore reale (unità) e mostra metri
    (function init() {
      // ✅ fallback coerente: 1 metro = factor unità (10dm o 100cm)
      const cm = clampCm(parseInt(cmInput.value || String(factor), 10));
      cmInput.value = String(cm);

      if (propInput) propInput.value = cmToMetersDisplay(cm, factor).trim().replace(",", ".") + " m";

      if (cm % factor === 0) {
        metersInput.value = String(cm / factor).replace(".", ",");
      } else {
        metersInput.value = cmToMetersDisplay(cm, factor);
      }
    })();

    metersInput.addEventListener("keydown", (e) => {
      const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab", "Enter", "Home", "End"];
      if (allowed.includes(e.key)) return;

      if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;

      if (e.key.length === 1 && !/[0-9.,]/.test(e.key)) e.preventDefault();

      if ((e.key === "," || e.key === ".") && /[.,]/.test(metersInput.value)) {
        const sel = metersInput.selectionStart !== metersInput.selectionEnd;
        if (!sel) e.preventDefault();
      }
    });

    const isAllowedValue = (val) => /^\d*([.,]\d{0,2})?$/.test(val);

    metersInput.addEventListener("beforeinput", (e) => {
      if (e.inputType && e.inputType.startsWith("delete")) return;
      if (typeof e.data !== "string") return;

      const el = metersInput;
      const start = el.selectionStart ?? el.value.length;
      const end = el.selectionEnd ?? el.value.length;

      const next = el.value.slice(0, start) + e.data + el.value.slice(end);

      if (!isAllowedValue(next)) {
        e.preventDefault();
        showError();
      }
    });

    metersInput.addEventListener("paste", (e) => {
      e.preventDefault();

      const pasted = (e.clipboardData || window.clipboardData).getData("text") || "";
      const el = metersInput;
      const start = el.selectionStart ?? el.value.length;
      const end = el.selectionEnd ?? el.value.length;

      const next = el.value.slice(0, start) + pasted + el.value.slice(end);
      metersInput.value = sanitizeToMax2Decimals(next);

      showError("");
      applyFromMeters(false, false);
    });

    metersInput.addEventListener("input", () => {
      const raw = metersInput.value;
      const sanitized = sanitizeToMax2Decimals(raw);
      if (sanitized !== raw) metersInput.value = sanitized;

      const trimmed = String(metersInput.value || "").trim();

      if (trimmed !== "" && !isValidMax2Decimals(trimmed) && !/^\d+[.,]$/.test(trimmed)) {
        showError("Inserisci un valore valido (es. 1,20)");
        return;
      }

      const cmRaw = metersStringToUnitInt(trimmed, factor);

      if (cmRaw === "INVALID_STEP") {
        showError("Inserisci multipli di 0,10 m (es. 1,20)");
        return;
      }

      if (typeof cmRaw === "number") {
        const { minCm, maxCm } = getRules();

        if (cmRaw < minCm) {
          showError(`Minimo: ${cmToMetersDisplay(minCm, factor)} m`);
          return;
        }

        if (maxCm !== null && cmRaw > maxCm) {
          showError(`Disponibilità massima: ${cmToMetersDisplay(maxCm, factor)} m`);
          return;
        }

        showError("");
        cmInput.value = String(cmRaw);
      }
    });

    metersInput.addEventListener("change", (e) => {
      e.stopPropagation();
      const ok = applyFromMeters(true, false);
      if (!ok && !isCartUpdates) metersInput.reportValidity();
    });

    metersInput.addEventListener("blur", () => {
      const raw = String(metersInput.value || "").trim();
      if (!raw) return;
      applyFromMeters(true, false);
    });

    metersInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const ok = applyFromMeters(true, false);
        if (!ok) {
          if (!isCartUpdates) metersInput.reportValidity();
          return;
        }
        const cartEl =
          wrap.closest("cart-items") ||
          wrap.closest("cart-drawer-items") ||
          document.querySelector("cart-items") ||
          document.querySelector("cart-drawer-items");
        if (cartEl && typeof cartEl.updateQuantity === "function") {
          cartEl.updateQuantity(
            cmInput.dataset.index,
            cmInput.value,
            metersInput.getAttribute("name"),
            getUpdatedPropertiesForCart()
          );
        }
      }
    });

    const applyBtn = wrap.querySelector(".js-meters-qty__apply");
    if (applyBtn) {
      applyBtn.addEventListener("click", () => {
        const ok = applyFromMeters(true, false);
        if (!ok) {
          if (!isCartUpdates) metersInput.reportValidity();
          return;
        }
        // closest() può fallire se wrap è detached dopo un re-render — fallback a document.querySelector
        const cartEl =
          wrap.closest("cart-items") ||
          wrap.closest("cart-drawer-items") ||
          document.querySelector("cart-items") ||
          document.querySelector("cart-drawer-items");
        if (cartEl && typeof cartEl.updateQuantity === "function") {
          cartEl.updateQuantity(
            cmInput.dataset.index,
            cmInput.value,
            metersInput.getAttribute("name"),
            getUpdatedPropertiesForCart()
          );
        }
        metersInput.focus();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => API.initAll());
  } else {
    API.initAll();
  }

  const staticTargets = [
    document.getElementById("CartDrawer"),
    document.getElementById("main-cart-items"),
  ];

  const productInfoTargets = Array.from(document.querySelectorAll(".product__info-container"));
  const targets = [...staticTargets, ...productInfoTargets].filter(Boolean);

  const observers = [];
  targets.forEach((t) => {
    const obs = new MutationObserver(() => {
      API.initWithin(t);
    });
    obs.observe(t, { childList: true, subtree: true });
    observers.push(obs);
  });
})();
